import { cn } from "@/lib/utils";
import * as React from "react";
import { PrevalenceIcon } from "./PrevalenceIcon";

export function PrevalenceBadge({ prevalence }: { prevalence?: string }) {
    if (!prevalence) return null;
    const badgeClass = cn(
        "flex items-center gap-1 px-2 py-1 rounded-md font-semibold text-[0.8rem] shadow-sm border",
        prevalence === "ubiquitous"
            ? "bg-green-100 text-green-800 border-green-200"
            : prevalence === "common"
            ? "bg-blue-100 text-blue-800 border-blue-200"
            : prevalence === "uncommon"
            ? "bg-yellow-100 text-yellow-800 border-yellow-200"
            : "bg-gray-100 text-gray-700 border-gray-200",
    );
    return (
        <span className={badgeClass}>
            <PrevalenceIcon prevalence={prevalence} />
            <span className="capitalize">{prevalence}</span>
        </span>
    );
}
